import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3de10950"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "plan-card-error"
}
const _hoisted_5 = { key: 0 }

import { ref, onBeforeMount } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { assertNotNull } from '@/helpers/typing'

import { BillingView, PlanView } from '@/models/billing'
import { platform } from '@/services/platform'
import {
  GoogleBillingUnavailableError,
  UserCancelledError,
} from '@/services/cordova.purchase.types'
import { ValidationError } from '@/models/error'

import AppButton from '@/app/components/button/AppButton.vue'
import SubscribePopup from './SubscribePopup.vue'
import { Mixpanel } from '@/analytics/mixpanel'
import { trialByPlan15535Treatment } from '@/services/ab/15535_trial_by_plan'

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingSubscribeButton',
  props: {
    billing: null,
    plan: null,
    location: null
  },
  setup(__props: any) {

const props = __props as {
  billing: BillingView
  plan: PlanView
  location?: string
};



const wait = useWait()

const errorRef = ref<string | null>(null)
const popup = ref<InstanceType<typeof SubscribePopup> | null>(null)

const useButtonOutlinedStyle = props.plan.id === 'plan_monthly'
const buttonVariantClass = `subscribe-button--${props.plan.id}`

const isAndroidApp = ref<boolean>(false)
onBeforeMount(async () => {
  isAndroidApp.value = await platform.isNativeAndroidApp()
})

async function subscribe(): Promise<void> {
  Mixpanel.trackStartTrial(props.plan, props.location || '')
  if (props.billing.isAppStore()) {
    try {
      errorRef.value = null
      wait.start('BillingSubscribe')
      await props.billing.subscribeTo(props.plan)
      wait.end('BillingSubscribe')
    } catch (error) {
      if (error instanceof UserCancelledError) {
        errorRef.value = 'cancelled'
      } else if (error instanceof ValidationError) {
        errorRef.value = error.getOne('receipt')
      } else if (error instanceof GoogleBillingUnavailableError) {
        errorRef.value =
          "We couldn't initiate your purchase. Please ensure that you are logged into your Google account on your device, and you have installed the latest version of Google Play. Alternatively, you can subscribe at https://www.shortform.com/app/billing in a web browser."
      } else if ('message' in (error as any)) {
        errorRef.value = (error as any).message
      } else {
        errorRef.value = ''
      }
      wait.end('BillingSubscribe')
    }
  } else {
    assertNotNull(popup.value).show()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_wait, {
      class: "subscribe-button__wrapper",
      for: "BillingSubscribe"
    }, {
      waiting: _withCtx(() => [
        _createVNode(AppButton, {
          class: _normalizeClass(["subscribe-button", buttonVariantClass]),
          outlined: useButtonOutlinedStyle,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Subscribing "),
            _createVNode(_component_button_spinner)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(AppButton, {
          class: _normalizeClass(["subscribe-button", buttonVariantClass]),
          outlined: useButtonOutlinedStyle,
          onClick: subscribe
        }, {
          default: _withCtx(() => [
            (_unref(trialByPlan15535Treatment)())
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Subscribe Now"))
              : (__props.billing.isTrialOver)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Subscribe"))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "Start Free Trial"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (errorRef.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(" Error subscribing"),
          (errorRef.value !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, ": " + _toDisplayString(errorRef.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(SubscribePopup, {
      ref_key: "popup",
      ref: popup,
      billing: __props.billing,
      plan: __props.plan
    }, null, 8, ["billing", "plan"])
  ], 64))
}
}

})